import React, { useState } from 'react';
import Header from './Header';
import SidebarNav from '../product/SidebarNav';

const DashboardLayout = ({ children }) => {
    const [sidebarOpen, setSidebarOpen] = useState(false);

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    return (
        <div className="min-h-screen bg-surface-secondary transition-colors duration-200">
            <div className="flex h-screen overflow-hidden">
                {/* Sidebar */}
                <div className={`
                    fixed inset-y-0 left-0 z-50 w-64 transform transition-transform duration-300 ease-in-out
                    ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'}
                    md:relative md:translate-x-0 md:flex md:flex-col
                `}>
                    <SidebarNav />
                </div>

                {/* Sidebar overlay for mobile */}
                {sidebarOpen && (
                    <div
                        className="fixed inset-0 z-40 bg-black bg-opacity-50 md:hidden"
                        onClick={toggleSidebar}
                    />
                )}

                {/* Main content area */}
                <div className="flex-1 flex flex-col overflow-hidden">
                    {/* Header */}
                    <Header onMenuToggle={toggleSidebar} />

                    {/* Main content */}
                    <main className="flex-1 overflow-y-auto bg-surface-secondary transition-colors duration-200">
                        <div className="mx-auto w-full max-w-[1280px] px-3 py-6 pb-20 md:px-4 md:pb-8 lg:px-6">
                            {children}
                        </div>
                    </main>
                </div>
            </div>
        </div>
    );
};

export default DashboardLayout; 